<template>
 <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '300px' : '150px'">
        <el-form-item label="原始CDN域名" prop="originalDomain" >
          <el-input v-model="dataForm.originalDomain" placeholder="原始CDN域名" class="input-item"></el-input>
      </el-form-item>
         <el-form-item label="目标CDN域名" prop="targetDomain" >
          <el-input v-model="dataForm.targetDomain" placeholder="目标CDN域名" class="input-item"></el-input>
      </el-form-item>
      <el-form-item label="代理服务域名" prop="proxyDomain" >
          <el-input v-model="dataForm.proxyDomain" placeholder="代理服务域名" class="input-item"></el-input>
      </el-form-item>
      <el-form-item label="密钥" prop="secretKey" >
          <el-input v-model="dataForm.secretKey" placeholder="密钥" class="input-item"></el-input>
      </el-form-item>
          <el-form-item label="默认过期时间（秒）" prop="defaultExpirySeconds">
          <el-input v-model="dataForm.defaultExpirySeconds" placeholder="默认过期时间（秒）" class="input-item"></el-input>
      </el-form-item>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
      </el-form>
</template>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      imageType: ["jpg","jpeg","png","gif","bmp","webp"],
      visible: false,
      url: '',
      adImg: '',
      appLogo: '',
      dataForm: {
        id: '',
        originalDomain:'',
        targetDomain: '',
        proxyDomain:'',
        defaultExpirySeconds:'',
        secretKey:''
      }
    }
  },
  computed: {
    dataRule () {
      return {

      }
    }
  },
  created(){
    this.init ()
    this.url = `${process.env.VUE_APP_API_TARGET}${process.env.VUE_APP_BASE_API}/sys/oss/upload?token=${Cookies.get('token')}`

  },
  methods: {
    init () {
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        this.getInfo()
      })
    },
     // 上传之前
     beforeUploadHandle (file) {

       return true;
   },
    successHandle(fileList){
      if(fileList.length>0){
        this.adImg = fileList[0].url
      }else{
        this.adImg=""
      }

      this.dataForm.adImg = this.adImg
    },
       // 上传成功
   successHandle_old (res, file) {

     if(res.code == 0){
       this.adImg = res.data.src,
       this.dataForm.adImg = res.data.src
     }else{
       return this.$message.error(res.msg)
     }
   },
   // 上传之前
   beforeUploadHandleLogo (file) {

       return true;
   },
    successHandleLogo(fileList){
      if(fileList.length>0){
        this.appLogo = fileList[0].url
      }else{
        this.appLogo=""
      }

      this.dataForm.appLogo = this.appLogo
    },
       // 上传成功
   successHandleLogo_old (res, file) {
     if(res.code == 0){
       this.appLogo = res.data.src
       this.dataForm.appLogo = res.data.src
     }else{
       return this.$message.error(res.msg)
     }
   },
    // 获取信息
    getInfo () {
      this.$http.get(`/videocdnconfig/config`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        this.appLogo = res.data.appLogo
        this.adImg = res.data.adImg
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/videocdnconfig/config/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style>
  .input-item{
    width: 400px;
  }
</style>
